import { List } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { TrashTimeoutIcon } from 'src/assets/icons'
import { MobileBottomLayout, PaginationButtons } from 'src/components'
import { useCancelScanDraftsRemove, useNotification, useRemoveScanDrafts } from 'src/hooks'
import { IDraftScanRespDto } from 'src/types'

import { GridItem } from './item.component'

interface IProps {
  data?: IDraftScanRespDto[]
}

export const ScanDraftsGrid = ({ data }: IProps) => {
  const [t] = useTranslation()
  const { mutateAsync: removeDrafts } = useRemoveScanDrafts()
  const { mutateAsync: cancelRemove } = useCancelScanDraftsRemove()
  const { notify } = useNotification()

  const handleDelete = (id: string) => async () => {
    const resp = await removeDrafts([id])
    if (!resp) return
    notify({
      message: t('items-delete-notification.v'),
      icon: <TrashTimeoutIcon />,
      onButtonClick: async () => {
        await cancelRemove({ ids: [id] })
      },
      timeout: 14000,
    })
  }

  return (
    <>
      <List sx={{ width: '100%' }}>
        {data?.map((item) => (
          <GridItem handleDelete={handleDelete} item={item} key={item.id} />
        ))}
      </List>
      <MobileBottomLayout>
        <PaginationButtons buttonsOnly />
      </MobileBottomLayout>
    </>
  )
}
